import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { fetchRuntimeConfig } from './lib/runtimeConfig'

// Fetch runtime config before rendering so subdomain routing
// can use the backend-configured base domain (e.g., clienta.sagarmatha.ai)
fetchRuntimeConfig()
  .catch(() => {
    console.warn('Failed to load runtime config, using defaults')
  })
  .finally(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )
  })
